import * as activityConstants from '../../Activity/activity.constants';

export function removePromoCodeFromList(promoCodes, promoCodeHubId) {
  return promoCodes.filter((promoCode) => promoCode.get(activityConstants.HUB_ID) !== promoCodeHubId);
}
